export const DataConf = {
  initialState: {
    data: [],
    meta: {},
    loading: false,
    error: null,
  },
};
